import React from "react";
import DialogSkeleton from "./dialogSkeleton";
import { Shortcut, ShortcutGroup } from "modules/shortcuts/models";
import { Typography } from "@mui/material";

import "../../styles/deleteShortcutsDialog.sass";

interface IDeleteShortcutsDialogProps {
    show: boolean;
    onClose: () => void;
    onDeleteSelectedShortcuts: (shortcutsToDelete: Shortcut[], shortcutGroupsToDelete: ShortcutGroup[]) => void;
    shortcutsToDelete: Shortcut[];
    shortcutGroupsToDelete: ShortcutGroup[];
}

const DeleteShortcutsDialog: React.FC<IDeleteShortcutsDialogProps> = ({
    show,
    onClose,
    onDeleteSelectedShortcuts,
    shortcutsToDelete,
    shortcutGroupsToDelete
}) => {
    const [dialogTitle, setDialogTitle] = React.useState("");
    const [shortcutGroupBodyText, setShortcutGroupBodyText] = React.useState("");
    const [shortcutBodyText, setShortcutBodyText] = React.useState("");

    const setDialogTitleAndBody = () => {
        let dialogTitle = "";
        let dialogBodyShortcutGroup = "";
        let dialogBodyShortcut = "";

        const shortcutGroupPlural = shortcutGroupsToDelete.length > 1 ? 's' : '';
        const shortcutPlural = shortcutsToDelete.length > 1 ? 's' : '';

        if (shortcutsToDelete.length > 0 && shortcutGroupsToDelete.length > 0) {
            dialogTitle = `Delete Shortcut Group${shortcutGroupPlural} and Shortcut${shortcutPlural}`;
            dialogBodyShortcutGroup = `${shortcutGroupsToDelete.length} shortcut group${shortcutGroupPlural}`;
            dialogBodyShortcut = `${shortcutsToDelete.length} shortcut${shortcutPlural}`;
        }
        else if (shortcutGroupsToDelete.length > 0) {
            dialogTitle = `Delete Shortcut Group${shortcutGroupPlural}`;
            dialogBodyShortcutGroup = `${shortcutGroupsToDelete.length} shortcut group${shortcutGroupPlural}`;
        }
        else if (shortcutsToDelete.length > 0) {
            dialogTitle = `Delete Shortcut${shortcutPlural}`;
            dialogBodyShortcut = shortcutsToDelete.length === 1 ? `${shortcutsToDelete[0].name}` : `${shortcutsToDelete.length} shortcut${shortcutPlural}`;
        }

        setDialogTitle(dialogTitle);
        setShortcutGroupBodyText(dialogBodyShortcutGroup);
        setShortcutBodyText(dialogBodyShortcut);
    }

    React.useEffect(() => { 
            setDialogTitleAndBody();
        },
        [shortcutsToDelete, shortcutGroupsToDelete]
    );

    return <DialogSkeleton
        show={show}
        onClose={onClose}
        onDialogActionButtonClick={() => onDeleteSelectedShortcuts(shortcutsToDelete, shortcutGroupsToDelete)}
        dialogTitle={dialogTitle}
        dialogActionButtonLabel="Delete"
        dialogActionButtonClassName="shortcuts-delete-button"
        dialogContentClassName="delete-shortcuts-content"
        maxWidth="sm"
    >
        <Typography
            className="delete-dialog-content"
        >
            You're about to permanently delete <b>{shortcutGroupBodyText}</b>{shortcutGroupBodyText !== "" && shortcutBodyText !== "" && " and "}<b>{shortcutBodyText}</b>. You cannot undo this action.
            <br/>
            <br/>
            Do you want to continue?
        </Typography>
    </DialogSkeleton>;
};

export default DeleteShortcutsDialog;
